<div class="content">
    <p>Si deseas eliminar tu cuenta y todos sus datos, envíanos un correo a {{ mailContacto }}</p>
</div>
